export const getSpecialtiesAsStrings = specialties =>
  specialties && specialties.map((item, index) => (index ? item.toLowerCase() : item)).join(', ');

export const filterSpecialties = all => specialties => all && all.filter(item => specialties.includes(item.id));
